<template>
  <nav v-if="horizontal" class="wet-nav wet-header-nav">
    <ul id="menu-front-page-menu" class="reset flex wet-nav-list">
      <li
        id="menu-item-801"
        class="menu-item menu-item-type-post_type menu-item-object-page menu-item-home"
        :class="{
          'menu-item-has-children': item.submenu,
        }"
        v-for="(item, id) in menu"
        :key="id"
      >
        <router-link v-if="item.route === routeType.app" :to="item.url">{{item.title}}</router-link>
        <a v-else-if="item.route === routeType.blog" :href="`${configEnv.wpApiServer}/${item.url}`">{{item.title}}</a>
        <a v-else :href="item.url">{{item.title}}</a>
        <ul
          v-if="item.submenu"
          class="sub-menu"
        >
          <li
            v-for="(subitem, subid) in item.submenu"
            :key="subid"
          >
            <router-link
              v-if="subitem.route === routeType.app"
              :to="subitem.url"
              @click.native="$emit('click')"
            >{{subitem.title}}</router-link>
            <a
              v-else-if="subitem.route === routeType.blog"
              :href="`${configEnv.wpApiServer}/${subitem.url}`"
              @click="$emit('click')"
            >{{subitem.title}}</a>
            <a
              v-else
              :href="subitem.url"
              @click="$emit('click')"
            >{{subitem.title}}</a>
          </li>
        </ul>
      </li>
    </ul>
  </nav>
  <ul v-else class="list-unstyled mb-0 p-3 border-bottom">
    <li
      class=""
      v-for="(item, index) in menu"
      :key="index"
    >
      <router-link
        v-if="item.route === routeType.app"
        :to="item.url"
        :class="{
          'wet-append-chevron-right': item.submenu,
        }"
        class="py-2 w-100"
        @click.native="menuClick(index)"
      >{{item.title}}</router-link>
      <a
        v-else-if="item.route === routeType.blog"
        :href="`${configEnv.wpApiServer}/${item.url}`"
        :class="{
          'wet-append-chevron-right': item.submenu,
        }"
        class="py-2 w-100"
      >{{item.title}}</a>
      <a
        v-else
        :href="item.url"
        :class="{
          'wet-append-chevron-right': item.submenu,
        }"
        class="py-2 w-100"
      >{{item.title}}</a>
      <ul
        v-if="item.submenu"
        class="list-unstyled"
        v-collapse="openedSubmenu[index]"
      >
        <li
          v-for="(subitem, subid) in item.submenu"
          :key="subid"
        >
          <router-link
            v-if="subitem.route === routeType.app"
            :to="subitem.url"
            class="pl-3 py-2 w-100"
            @click.native="$emit('click')"
          >{{subitem.title}}</router-link>
          <a
            v-else-if="subitem.route === routeType.blog"
            :href="`${configEnv.wpApiServer}/${item.url}`"
            class="pl-3 py-2 w-100"
          >{{item.title}}</a>
          <a
            v-else
            :href="subitem.url"
            class="pl-3 py-2 w-100"
          >{{item.title}}</a>
        </li>
      </ul>
    </li>
  </ul>
</template>
<script>
import routeType from "@/enums/routeType";
import configEnv from "@/enums/configEnv";

export default {
  computed: {
    configEnv() {
      return configEnv
    },
    routeType() {
      return routeType
    }
  },
  props: {
    menu: {
      type: Array,
      default: () => [],
    },
    horizontal: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      openedSubmenu: [],
    };
  },
  methods: {
    submenuToggle(i) {
      this.$set(this.openedSubmenu, i, !this.openedSubmenu[i]);
    },
    menuClick(i) {
      if (this.menu[i].submenu) {
        this.submenuToggle(i);
      } else {
        window.location = this.menu[i].url;
      }
    },
  },
};
</script>
